import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn } from 'typeorm';

@Entity()
export class ConfigEntity {
  @PrimaryGeneratedColumn()
  id: number;

  @CreateDateColumn()
  createDate: Date;

  @Column({default: true})
  userAuthEnabled: boolean;

  @Column({default: true})
  userRegisterEnabled: boolean;

  @Column({default: true})
  userRegisterModerated: boolean;

  @Column({default: false})
  userRegisterUseCaptcha: boolean;

  @Column({default: false})
  userLoginUseCaptcha: boolean;  
}


